/**
 * @deprecated Search should be singular store.
 */

import { CollectionType } from '@/enums/collection-type';
import { providerPageExpTrackEvent } from '@/helpers/experiments/popular-provider-page-exp-helper';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import VueRouter from 'vue-router';
import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';

// STATE
const state = () => ({
	isLoading: false as boolean,
	query: '' as string,
	person_id: null as number | null,
	isShown: false as boolean,
	currentView: '' as string,
});

type State = ReturnType<typeof state>;

// GETTERS
const getters: GetterTree<State, any> = {
	isShown: state => {
		return state.isShown;
	},
	query: state => {
		return state.query;
	},
	isLoading: state => {
		return state.isLoading;
	},
	currentView: state => {
		return state.currentView;
	},
};

// ACTIONS
const actions: ActionTree<State, any> = {
	reset: async ({ commit }) => {
		commit('RESET');
	},

	setShown({ commit, rootGetters }, value: boolean) {
		const referralModuleContext = rootGetters['titleDetails/refferalModuleContext'];
		const contexts = referralModuleContext ? [referralModuleContext] : [];
		const payload = { contexts, value };
		commit('SET_SHOWN', payload);
	},

	setSearchbarFocus({ commit }, value: boolean) {
		commit('SET_SEARCHBAR_FOCUS', value);
	},

	setCurrentView({ commit }, view: string) {
		commit('SET_VIEW', view);
	},

	search: async (
		{ commit, rootState, rootGetters },
		{ searchQuery, router }: { searchQuery: string; router: VueRouter }
	) => {
		// reset if the search query is empty
		if (!searchQuery || searchQuery.length === 0) {
			commit('RESET');
		}

		commit('SET_QUERY', searchQuery);
	},

	/**
	 * routing to search page along with setting filters.
	 */
	goToSearch({ dispatch }, { searchString, personId }: { searchString: string; personId?: number }) {
		dispatch('user/saveSearchTerm', searchString, { root: true });
		const routeQuery = {
			q: searchString,
			person_id: personId,
		};

		dispatch('filter/updateRouterState', { collectionType: CollectionType.SEARCH, routeQuery }, { root: true });
	},
};

// MUTATIONS
const mutations: MutationTree<State> = {
	RESET: state => {
		state.query = '';
		// state.isShown = false;
	},

	SET_VIEW: (state, view) => {
		state.currentView = view;
	},
	SET_QUERY(state, q: string) {
		state.query = q;
	},
	SET_PERSON_ID(state, personId: number) {
		state.person_id = personId;
	},
	SET_SHOWN(state, payload) {
		const { contexts, value } = payload;
		if (state.isShown !== value) {
			state.isShown = value;
			TrackingHelper.trackEvent(
				'userinteraction',
				{
					action: value ? 'open_suggester' : 'close_suggester',
				},
				contexts
			);

			providerPageExpTrackEvent({
				label: value ? 'open_suggester' : 'close_suggester',
				action: 'click',
			});
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
} as Module<State, any>;
